import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { useTable, useGlobalFilter, usePagination } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment,faFolderOpen,faFilePen,faCaretRight  } from '@fortawesome/free-solid-svg-icons';
import 'font-awesome/css/font-awesome.min.css';
import '../css/usermain.css';
import axios from 'axios';
import AddTaskPopup from './AddTaskPopup';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import AcademicGuruLogo from '../assets/academicguru.png';
import LeelagreenLogo from '../assets/leelagreen.jpg';
import AGPHLogo from '../assets/agph.png';
import IJISEMLogo from '../assets/ijisem.png';
import SlideTask from '../UserComponents/SlideTask';
import ProjectDetailModal from '../UserComponents/ProjectDetailModal';
import TaskTimerAction from '../UserComponents/TaskTimerAction';
import { useNavigate } from 'react-router-dom';


const UserStatsAssignBy = ({selectedUser}) => {
     const [taskData, setTaskData] = useState([]);
      const [showPopup, setShowPopup] = useState(false);
      const [projectData, setProjectData] = useState([]);
      const [showSidebar, setShowSidebar] = useState(false);
      const [selectedRowData, setSelectedRowData] = useState(null);
      const [projectNames, setProjectNames] = useState({});
      const [selectedProject, setSelectedProject] = useState(null);
      const navigate = useNavigate();
      const [users, setUserOptions] = useState([]);
      const [selectedUserOption, setselectedUserOption] = useState(null);
      const [selectedStatus, setSelectedStatus] = useState("Todo");
      const [hoveredRowIndex, setHoveredRowIndex] = useState(null);

      
      

      
    useEffect(() => {
      const fetchUsers = async () => {
        try {
          const res = await axios.get("/api/users.php");
          setUserOptions(res.data);
        } catch (error) {
          console.error("Failed to load users:", error);
        }
      };
      fetchUsers();
    }, []);


      useEffect(() => {
        fetch("/api/projectname.php?method=getNames")
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              setProjectNames(data.projects);
            }
          });
      }, []);

          const updateDuration = useCallback((taskId, newTimeObj) => {
            const task = taskData.find(t => t.id === taskId);
            let sessionArray = [];

            try {
              const parsed = JSON.parse(task?.duration || '[]');
              sessionArray = Array.isArray(parsed) ? parsed : [];
            } catch {
              sessionArray = [];
            }

            const lastSession = sessionArray[sessionArray.length - 1];
            let updatedSessions = [...sessionArray];

            // If trying to add a new "start"
            if (newTimeObj.start) {
              if (!lastSession || (lastSession.start && (lastSession.pause || lastSession.end))) {
                // Only add new start if no session or last session is finished
                updatedSessions.push({ start: newTimeObj.start });
              } else {
                console.warn("Cannot add new 'start': last session still running");
                return;
              }
            }
    
            else if (newTimeObj.pause || newTimeObj.end) {
              if (lastSession && lastSession.start && !lastSession.pause && !lastSession.end) {
                // Update the last active session with pause or end
                updatedSessions[updatedSessions.length - 1] = {
                  ...lastSession,
                  ...newTimeObj,
                };
              } else if (newTimeObj.pause && lastSession && lastSession.pause) {
                // If trying to pause again after a pause, treat it as new start
                updatedSessions.push({ start: newTimeObj.pause });
              } else {
                console.warn("Cannot add 'pause' or 'end': no active session with 'start'");
                return;
              }
            }
    
            // Save updated duration to DB
            fetch("/api/taskduration.php", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                method: "updateDuration",
                id: taskId,
                duration: JSON.stringify(updatedSessions),
              }),
            })
              .then(res => res.json())
              .then(response => {
                if (response.success) {
                  console.log("Duration updated");
          
                  // Update local state
                  setTaskData(prev =>
                    prev.map(task =>
                      task.id === taskId ? { ...task, duration: JSON.stringify(updatedSessions) } : task
                    )
                  );
                } else {
                  console.error("Update failed:", response.message);
                }
              })
              .catch(error => console.error("Error updating duration:", error));
          }, [taskData]);

      const handleStart = useCallback((task) => {
        const now = new Date().toISOString();

        // Check if another task is already running
        const runningTask = taskData.find(t => {
          try {
            const sessions = JSON.parse(t.duration || '[]');
            const last = sessions[sessions.length - 1];
            return last && last.start && !last.pause && !last.end;
          } catch {
            return false;
          }
        });

        // If another task is running and it's not the current one, block
        if (runningTask && runningTask.id !== task.id) {
          alert("Only one task can run at a time. Please pause or end the other task first.");
          return;
        }

        updateDuration(task.id, { start: now });
      }, [taskData, updateDuration]);

      const handlePause = useCallback((task) => {
        const now = new Date().toISOString();

        // Check if this task is already paused and trying to resume (unpause)
        const sessions = (() => {
          try {
            return JSON.parse(task.duration || '[]');
          } catch {
            return [];
          }
        })();

        const last = sessions[sessions.length - 1];

        const isResuming =
          last && last.start && last.pause && !last.end;

        if (isResuming) {
          // Check if any other task is already running
          const runningTask = taskData.find(t => {
          try {
            const s = JSON.parse(t.duration || '[]');
            const l = s[s.length - 1];
            return (
              l &&
              l.start &&
              !l.pause &&
              !l.end &&
              t.id !== task.id
            );
          } catch {
            return false;
          }
        });

        if (runningTask) {
          alert("Only one task can run at a time. Pause or end the other task first.");
          return;
        }

        // Resume by creating a new session
        updateDuration(task.id, { start: now });
        return;
      }

      // Otherwise, apply normal pause
      updateDuration(task.id, { pause: now });

    }, [taskData, updateDuration]);

      const handleEnd = useCallback((task) => {
        const now = new Date().toISOString();
        updateDuration(task.id, { end: now });
      }, [updateDuration]);
    
      useEffect(() => {
        if (!selectedUser) return; // Wait for user to be available

        // Fetch tasks assigned by this user
        axios.get(`/api/assignbyuser.php?action=tasks`, {
          withCredentials: true,
        })
          .then(res => {
            setTaskData(res.data);
          })
          .catch(err => console.error('Task fetch error:', err));

        // Fetch all projects
        axios.get('/api/assignbyuser.php?action=projects', {
          withCredentials: true,
        })
          .then(res => setProjectData(res.data))
          .catch(err => console.error('Project fetch error:', err));
      }, [selectedUser]); // ✅ Add `user` as a dependency

      const filteredUsers = users
  .filter(assignuser =>
    assignuser.name !== selectedUser &&
    (
      taskData.some(task => task.assign_to === assignuser.name) || 
      (projectData?.team || []).includes(assignuser.name)
    )
  )
  .sort((a, b) =>
    a.name === selectedUserOption ? -1 : b.name === selectedUserOption ? 1 : 0
  );

// Set default selection to first user if none selected
useEffect(() => {
  if (!selectedUserOption && filteredUsers.length > 0) {
    setselectedUserOption(filteredUsers[0].name);
  }
}, [filteredUsers, selectedUserOption]);



          const renderTaskStatusSquares = (taskCountJson) => {
            let parsed = {
              "Hold": 0,
              "To Do": 0,
              "Doing": 0,
              "Done": 0
            };

            try {
              if (typeof taskCountJson === 'string') {
                const temp = JSON.parse(taskCountJson);
                parsed = { ...parsed, ...temp };
              } else if (typeof taskCountJson === 'object' && taskCountJson !== null) {
                parsed = { ...parsed, ...taskCountJson };
              }
            } catch (e) {
              // silently fail
            }

            const colorMap = {
              'Hold': 'text-gray-300',
              'To Do': 'text-red-300',
              'Doing': 'text-yellow-300',
              'Done': 'text-green-300',
            };

            return (
              <div className="flex flex-wrap gap-0.5">
                {['Hold','To Do', 'Doing', 'Done'].map((key) =>
                  parsed[key] > 0
                    ? [...Array(parsed[key])].map((_, idx) => (
                        <FontAwesomeIcon
                          key={`${key}-${idx}`}
                          icon={faSquare}
                          className={`text-[9px] ${colorMap[key]}`}
                        />
                      ))
                    : null
                )}
              </div>
            );
          };

          const columns = useMemo(() => [

            {
              Header: "Project Name",
              accessor: "project_id", // still use project_id to map
              Cell: ({ value }) => (
                <span title={value}>
                  {projectNames[value] || <span className='bg-gray-300 p-1 rounded shadow-xl text-gray-800 font-semibold'>Single Task</span>}
                </span>
              )
            },
            { Header: "Task ID", accessor: "task_id" },
            { Header: "Task Name", accessor: "task_name" },
            {
              Header: "",
              accessor: "comment",
              Cell: ({ row }) => {
                let commentArray = [];
                const rawComment = row.original.comment;
    
                if (typeof rawComment === 'string') {
                  try {
                    const parsed = JSON.parse(rawComment);
                    commentArray = Array.isArray(parsed) ? parsed : [parsed];
                  } catch {
                    commentArray = rawComment ? [rawComment] : [];
                  }
                } else if (Array.isArray(rawComment)) {
                  commentArray = rawComment;
                } else if (rawComment) {
                  commentArray = [rawComment];
                }
                const commentCount = commentArray.length;
                return (
                  <div className="">
                    <button className="relative">
                      <FontAwesomeIcon icon={faComment} />
                      {commentCount > 0 && (
                        <span className="absolute bottom-4 left-3 bg-gray-600 text-white rounded-full text-[0.45rem] px-1">
                          {commentCount}
                        </span>
                      )}
                    </button>
                  </div>
                );
              },
            },
            { Header: "Assign To", accessor: "assign_to" },
            {
              Header: "Priority",
              accessor: "priority",
              Cell: ({ value }) => {
                let bgColor = "transparent";
                let textColor = "inherit";
                if (value === "Medium") {
                  bgColor = "#d1fae5"; // green-100
                } else if (value === "Urgent") {
                  bgColor = "#f87171"; // red-400
                  textColor = "white";
                }
                  return (
                    <div
                      style={{
                        fontSize: '12px',
                        textAlign: 'center',
                        borderRadius: '10px',
                        backgroundColor: bgColor,
                        color: textColor,
                      }}
                    >
                      {value}
                    </div>
                  );
              }
            },
            {
              Header: "Start Date",
              accessor: "start_date",
              Cell: ({ value }) => {
                if (!value) return "";
                const date = new Date(value);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
              }
            },
            {
            Header: "Tentative Time",
            accessor: "submission_date",
            Cell: ({ value }) => value ? `${value} hr ` : '',  // Custom display
          },
            {
              Header: "Action",
              accessor: "duration",
             Cell: ({ row }) => (
        <TaskTimerAction
          task={row.original}
          onStart={handleStart}
          onPause={handlePause}
          onEnd={handleEnd}
        />
      )
          } ], [handleStart, handlePause, handleEnd,  projectNames]);

        const projectColumns = useMemo(() => [
          {
            Header: "",
            accessor: "company_name",
            Cell: ({ value }) => {
              const companyLogoMap = {
                'IJISEM': IJISEMLogo,
                'Academic Guru': AcademicGuruLogo,
                'Leela Greens': LeelagreenLogo,
                'AGPH': AGPHLogo,
              };
              const logo = companyLogoMap[value];
              return logo ? (
                <img
                  src={logo}
                  alt={value}
                  className="h-6 w-6 rounded-full"
                  title={value}
                />
              ) : (
                <span>{value}</span>
              );
            }
          },
          { Header: "Project ID", accessor: "project_id" },
          { Header: "Name", accessor: "name" },
          { Header: "Client", accessor: "client" },
          { Header: "Category", accessor: "category" },
          { Header: "Manage By", accessor: "assign_to" },
          {
            Header: "Assignees",
            accessor: "team_members",
            Cell: ({ value }) => {
              if (!value) return null;
              const members = value
                .split(',')
                .map(m => m.trim())
                .filter(m => m.length > 0);

              return (
                <span
                  className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold text-gray-700 bg-gray-200"
                  title={members.join(', ')} // tooltip on hover
                >
                  {members.length}
                </span>
              );
            }
          },
          {
            Header: "Progress",
            accessor: "no_of_task",
            Cell: ({ value }) => renderTaskStatusSquares(value),
          },

          { Header: "Deadline", accessor: "submisssion_date" },
        ], []);

        const timecolumns = React.useMemo(
          () => [
            {
            Header: 'Date',
            accessor: 'timestamp',
            Cell: ({ value }) => {
              const date = new Date(value);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }
          }, 
        ],[]);


      const projecttime = useMemo(() => [
        {
          Header: '',
          accessor: 'created_at',
          Cell: ({ value }) => {
            const date = new Date(value);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
          },
        },
      ], []);


const filteredIndividualTasks = useMemo(() => {
  const normalizedStatus = selectedStatus === 'Todo' ? 'To Do' : selectedStatus;

  return Array.isArray(taskData)
    ? taskData.filter(task =>
        task.assign_to === selectedUserOption &&
        (selectedStatus === '' || task.status === normalizedStatus) 
      )
    : [];
}, [taskData, selectedUserOption, selectedStatus]);

const filteredTaskData = useMemo(() => {
  const normalizedStatus = selectedStatus === 'Todo' ? 'To Do' : selectedStatus;

  return Array.isArray(taskData)
    ? taskData.filter(task =>
        task.assign_to === selectedUserOption &&
        (selectedStatus === '' || task.status === normalizedStatus)
      )
    : [];
}, [taskData, selectedUserOption, selectedStatus]);



const filteredProjects = useMemo(() => {
  return Array.isArray(projectData)
    ? projectData.filter(project =>
        project.assign_to === selectedUserOption &&
        (selectedStatus === '' || project.status === selectedStatus)
      )
    : [];
}, [projectData, selectedUserOption, selectedStatus]);

const filteredProjectsTime = useMemo(() => {
  return Array.isArray(projectData)
    ? projectData.filter(project =>
        project.assign_to === selectedUserOption &&
        (selectedStatus === '' || project.status === selectedStatus)
      )
    : [];
}, [projectData, selectedUserOption, selectedStatus]);





      const {
        getTableProps: getProjectTableProps,
        getTableBodyProps: getProjectTableBodyProps,
        headerGroups: projectHeaderGroups,
        prepareRow: prepareProjectRow,
        page: projectPage,

      } = useTable(
        { columns: projectColumns, data: filteredProjects, initialState: { pageIndex: 0, pageSize: 20 } },
        useGlobalFilter,
        usePagination
      );

      // ✅ Keep this only ONCE:
      const {
        getTableProps: getProjectTimeTableProps, 
        getTableBodyProps: getProjectTimeTableBodyProps,
        headerGroups: projectTimeHeaderGroups, 
        rows: projectTimeRows,
        prepareRow: prepareProjectTimeRow,
      } = useTable({
        columns: projecttime,
        data: filteredProjectsTime,
      });


      // Individual Task Table
      const {
        getTableProps: getIndividualTableProps,
        getTableBodyProps: getIndividualTableBodyProps,
        headerGroups: individualHeaderGroups,
        prepareRow: prepareIndividualRow,
        page: individualPage,
      } = useTable(
        { columns, data: filteredIndividualTasks, initialState: { pageIndex: 0, pageSize: 20 } },
        useGlobalFilter,
        usePagination
      );

      const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
      } = useTable({ columns: timecolumns, data: filteredTaskData });

  return (
   <div className="container-dash  pt-5 px-3 pr-3 max-h-full">
    <p className='font-semibold m-1 my-3 text-gray-700 text-lg '>Work Assign By <span className='bg-green-200 shadow-xl rounded-lg px-3  text-gray-700'>{selectedUser}</span> To : </p>
          <div className='flex justify-between'>
            <div className="flex text-right mr-3 font-semibold text-gray-500 gap-2 mb-3">
    {filteredUsers.map(assignuser => (
      <button
        key={assignuser.id}
        onClick={() => setselectedUserOption(assignuser.name)}
        className={`px-3 py-1 rounded-sm text-sm shadow-lg ${
          selectedUserOption === assignuser.name
            ? 'bg-gray-700 text-white'
            : 'bg-white text-gray-700'
        }`}
      >
        {assignuser.name}
      </button>
    ))}
  </div>

             {/* Status and Date Filter */}
  <div className="flex gap-3 items-center mb-2">
    {/* Status Filter */}
    <select
      value={selectedStatus}
      onChange={(e) => setSelectedStatus(e.target.value)}
      className="px-1 py-[2px]   border border-gray-300 rounded text-xs text-gray-700 shadow bg-white"
    >
      <option value="">All Status</option>
      <option value="Todo">Todo</option>
      <option value="Doing">Doing</option>
      <option value="Done">Done</option>

    </select>

  </div>
          </div>
         
          <div className='bg-gray-100 p-3 px-5 shadow-xl  pr-10 rounded-sm h-screen overflow-y-auto max-h-150 scrollbar-hide'>
        <p className='font-semibold text-gray-500 text-xl py-2'><FontAwesomeIcon icon={faFilePen} className='text-red-300 mr-1'/>Tasks</p>

        <div className='border-l border-dotted border-gray-700  relative left-7 flex'>
            <table
        {...getTableProps()}
        className=""
      >
        <thead className="">
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th
                  {...column.getHeaderProps()}
                  className="p-5 text-left text-sm font-semibold text-gray-700 "
                >
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className="hover:bg-gray-50 "
              >
                {row.cells.map(cell => (
                  <td
                    {...cell.getCellProps()}
                    className=" py-2 text-xs text-gray-800 flex"
                  >
                .......<p className='pt-1'> {cell.render('Cell')} </p>......<FontAwesomeIcon icon={faCaretRight} className='pt-[5px] pr-2'/>
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
          <div className="min-w-[90%]">
            <div className='overflow-x-auto shadow-lg  rounded-lg overflow-y-auto max-h-150 scrollbar-hide '>
            <table {...getIndividualTableProps()} className=" divide-y bg-white min-w-full divide-gray-200 ">
              <thead className="bg-gray-700 sticky top-0 z-0">
                {individualHeaderGroups.map(headerGroup => {
                  const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
                  return (
                    <tr key={key} {...restHeaderGroupProps}>
                      {headerGroup.headers.map(column => {
                        const { key, ...restColumnProps } = column.getHeaderProps();
                        return (
                          <th
                            key={key}
                            {...restColumnProps}
                            className="px-3 py-3 text-left text-xs font-medium text-white uppercase tracking-wider whitespace-nowrap"
                          >
                            {column.render('Header')}
                          </th>
                        );
                      })}
                    </tr>
                  );
                })}
              </thead>
              <tbody {...getIndividualTableBodyProps()} className="divide-y divide-gray-200">
                {individualPage.map(row => {
                  prepareIndividualRow(row);
                  const { key, ...restRowProps } = row.getRowProps();
                  return (
                    <tr
                      key={key}
                      {...restRowProps}
                      className={`cursor-pointer ${hoveredRowIndex === row.id ? 'bg-gray-100' : ''}`}
                        onMouseEnter={() => setHoveredRowIndex(row.id)}
                      onClick={() => {
                        setSelectedRowData(row.original);
                        setShowSidebar(true);
                      }}
                    >
                      {row.cells.map(cell => {
                        const { key, ...restCellProps } = cell.getCellProps();
                        return (
                          <td
                            key={key}
                            {...restCellProps}
                            className="px-3 py-3 text-xs text-gray-700 "
                          >
                            {cell.render('Cell')}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>
          </div>
        </div>
         
        {/* 👇 Sidebar for Single Task */}
        <SlideTask
          show={showSidebar}
          onClose={() => setShowSidebar(false)}
          data={selectedRowData}
        />
        <p className='font-semibold text-gray-500 text-xl py-2'><FontAwesomeIcon icon={faFolderOpen} className='text-yellow-500 mr-1'/>Project</p>

      <div className='border-l border-dotted border-gray-700  relative left-7 flex'>
         <div className="overflow-x-auto scrollbar-hide ">
       <table {...getProjectTimeTableProps()} className="">
  <thead className="">
    {projectTimeHeaderGroups.map(headerGroup => (
      <tr {...headerGroup.getHeaderGroupProps()}>
        {headerGroup.headers.map(column => (
          <th
            {...column.getHeaderProps()}
             className="p-5 py-9 text-left text-sm font-semibold text-gray-700 "
          >
          </th>
        ))}
      </tr>
    ))}
  </thead>
  <tbody {...getProjectTimeTableBodyProps()} className="">
    {projectTimeRows.map(row => {
      prepareProjectTimeRow(row);
      return (
        <tr {...row.getRowProps()} className="hover:bg-gray-50">
          {row.cells.map(cell => (
            <td
              {...cell.getCellProps()}
              className="py-4 whitespace-nowrap text-xs flex"
            >
             ....... <p className='pt-1'>{cell.render('Cell')}</p> ......<FontAwesomeIcon icon={faCaretRight} className='pt-[5px] pr-2'/>
            </td>
          ))}
        </tr>
      );
    })}
  </tbody>
</table>

      </div>
      <div className="min-w-[90%] pt-9">
          <div className="overflow-x-auto bg-white rounded shadow w-full shadow-xl overflow-y-auto max-h-150 scrollbar-hide ">
        <table {...getProjectTableProps()} className="min-w-full divide-y divide-gray-200 ">
          <thead className="bg-gray-700 sticky top-0 z-0">
            {projectHeaderGroups.map(headerGroup => {
              const { key, ...restHeaderProps } = headerGroup.getHeaderGroupProps();
              return (
                <tr key={key} {...restHeaderProps}>
                  {headerGroup.headers.map(column => {
                    const { key, ...restColProps } = column.getHeaderProps();
                    return (
                      <th
                        key={key}
                        {...restColProps}
                        className="px-3 py-3 text-left text-xs font-medium text-white uppercase tracking-wider whitespace-nowrap"
                      >
                        {column.render('Header')}
                      </th>
                    );
                  })}
                </tr>
              );
            })}
          </thead>

          <tbody {...getProjectTableBodyProps()} className="divide-y divide-gray-200">
            {projectPage.map(row => {
              prepareProjectRow(row);
              const { key, ...restRowProps } = row.getRowProps();
              return (
                <tr key={key} {...restRowProps}  onClick={() => navigate(`/${row.original.project_id}?user=${row.original.assign_to}`)} className={`cursor-pointer ${hoveredRowIndex === row.id ? 'bg-gray-100' : ''}`}
                  onMouseEnter={() => setHoveredRowIndex(row.id)}>
                  {row.cells.map(cell => {
                    const { key, ...restCellProps } = cell.getCellProps();
                    return (
                      <td
                        key={key}
                        {...restCellProps}
                        className="px-3 py-3 text-xs text-gray-700 "
                      >
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>

        <ProjectDetailModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      </div>
      </div>
        

      </div>
      </div>
    
    {showPopup && <AddTaskPopup onClose={() => setShowPopup(false)} />}
    </div>
  )
}

export default UserStatsAssignBy